var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacilityType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #707070;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #0071f2;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44525",
    "data-name": "Rectangle 44525",
    className: "cls-1",
    width: 12,
    height: 12,
    transform: "translate(688 168)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_33",
    "data-name": "Mask Group 33",
    className: "cls-2",
    transform: "translate(-688 -168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3999",
    "data-name": "Group 3999",
    transform: "translate(149 -248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icons8-first-aid-kit",
    className: "cls-3",
    d: "M35.52,38a1.3,1.3,0,0,0-1.267,1.334v.292H32.62A1.661,1.661,0,0,0,31,41.311v1.46a.276.276,0,0,0,.274.269h.206v4.9a1.652,1.652,0,0,0,1.608,1.687h7.825A1.652,1.652,0,0,0,42.52,47.94v-4.9h.206A.276.276,0,0,0,43,42.771v-1.46a1.661,1.661,0,0,0-1.62-1.684H39.56v-.292A1.3,1.3,0,0,0,38.3,38Zm0,.533H38.3a.769.769,0,0,1,.732.8v.292h-4.24v-.292A.77.77,0,0,1,35.52,38.533Zm-2.9,1.627h8.76a1.127,1.127,0,0,1,1.087,1.151v1.2H31.533v-1.2A1.127,1.127,0,0,1,32.62,40.16Zm-.607,2.88h9.973v4.9a1.119,1.119,0,0,1-1.074,1.153H33.088a1.119,1.119,0,0,1-1.074-1.153Zm4.427.773a.267.267,0,0,0-.267.267v.96h-.96a.267.267,0,0,0-.267.267v1.04a.267.267,0,0,0,.267.267h.96V47.6a.267.267,0,0,0,.267.267h1.04a.267.267,0,0,0,.267-.267v-.987h.987A.267.267,0,0,0,39,46.347v-1.04a.267.267,0,0,0-.267-.267h-.987v-.96a.267.267,0,0,0-.267-.267Zm.48,1.855.2.3.1-.3v-.095c0,.147.267,0,.267,0h-.442v.507h-.6l.857.267c-.147,0-.084-.147-.084,0l-.393-.381-.114.238v.143c0-.147.147-.143,0-.143l.507.143-.507-.143.507-.124c.147,0-.293-.359-.293-.507Z",
    transform: "translate(508 378)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityType);
export default __webpack_public_path__ + "static/media/facilityType.84ddde209c7ff544945042a8d65b27cf.svg";
export { ForwardRef as ReactComponent };